import {DetailSearchForm, DetailSearchGrid} from "@/features/search";
import {filterValidValuesToObject} from "@/shared/lib";
import {vars} from "@/shared/lib/theme.css";
import {DetailSearchType} from "@/shared/model";
import {Column, Indicator} from "@/shared/ui";
import {createFileRoute} from "@tanstack/react-router";
import {Suspense} from "react";

export const Route = createFileRoute("/(auth)/_layout/search/detail-search")({
	component: DetailSearchScreen,
	validateSearch: (search: Partial<DetailSearchType>): Partial<DetailSearchType> => {
		return filterValidValuesToObject<DetailSearchType, DetailSearchType>(search);
	}
});

function DetailSearchScreen() {
	return (
		<Column fullWidth style={{gap: vars.size[32], paddingBottom: 100}}>
			<Column
				fullWidth
				style={{
					position: "sticky",
					top: 0,
					zIndex: 100,
					backgroundColor: vars.color.white,
					paddingBottom: vars.size[16]
				}}
			>
				<DetailSearchForm />
			</Column>
			<Suspense fallback={<Indicator />}>
				<DetailSearchGrid />
			</Suspense>
		</Column>
	);
}
